import CodeIcon from "@redotech/redo-icons/code-01_filled.svg";
import { SendWebhookStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface SendWebhookNodeData {
  deleteElements: (id: string) => void;
  step: PartialWithRequiredType<SendWebhookStep>;
}

export function SendWebhookNode(data: {
  id: string;
  data: SendWebhookNodeData;
  selected?: boolean;
}) {
  const { destinationUrl } = data.data.step;

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        disabled={data.data.step.disabled}
        icon={<RedoFeaturedIcon color="success" Icon={CodeIcon} size="xs" />}
        onDelete={() => data.data.deleteElements(data.id)}
        selected={data.selected}
        step={data.data.step}
        title="Send webhook"
      >
        <Flex className={NodeCSS.fullWidth} dir="column" justify="flex-start">
          <Text fontSize="xxs">Destination URL</Text>
          {destinationUrl ? (
            <Text className={NodeCSS.valueText}>{destinationUrl}</Text>
          ) : (
            <Text className={NodeCSS.placeholderText}>Needs configuration</Text>
          )}
        </Flex>
      </BaseNode>
      <Handle position={Position.Bottom} type="source" />
    </>
  );
}
